import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driverTypesAdapter = getAdapter({ idFieldName: 'value' });

const driverTypesSlice = createSlice({
  name: 'driverTypes',
  initialState: driverTypesAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setDriverTypes: (state, { payload: { driverTypes, source } }) => {
      driverTypesAdapter.setAll(state, driverTypes);
      state.source = source;
    },
  },
});

const selectors = driverTypesAdapter.getSelectors(({ driverTypes }) => driverTypes);

export const getDriverTypes = (state) => selectors.selectAll(state);

export const { setDriverTypes } = driverTypesSlice.actions;

export default driverTypesSlice.reducer;
